import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class RequerimientoService {
    private _requerimiento: BehaviorSubject<any> = new BehaviorSubject(null);
    private _requerimientos: BehaviorSubject<any[]> = new BehaviorSubject(null);

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for requerimiento
     */
    get requerimineto$(): Observable<any> {
        return this._requerimiento.asObservable();
    }

    /**
     * Getter for requerimientos
     */
    get requeriminetos$(): Observable<any[]> {
        return this._requerimientos.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get requerimineto
     *
     * @param email
     * @param curp
     * @param rfc
     */
    public getExpediente(email: string, curp: string, rfc: string): Observable<any> {
        return this._httpClient.get<any>(
            '/api/seaged-saga-registro-enrolamiento/v1/expedientes/registro/enrolamiento/expediente',
            {params: {email: email, curp: curp, rfc: rfc}}).pipe(
            map(response => response.data));
    }
}
